import _ from 'lodash';
import React, { Component } from 'react';
import { dp } from '../../../utils/shared';
import { DEFAULT_CYCLE } from './AlbuquerqueConstants';

class AlbuquerqueStoryFullScreen extends Component {
  constructor(props) {
    super(props);
    this._cycleTimeoutHandler = null;
  }

  componentDidMount() {
    this.setupCycle();
  }

  componentWillUnmount() {
    clearTimeout(this._cycleTimeoutHandler);
  }

  setupCycle = () => {
    const time = _.get(this.props.module, "contents.custom_fields.cycle_time.val", DEFAULT_CYCLE);
    this._cycleTimeoutHandler = setTimeout(() => {
      if (this.props.cycle) {
        this.props.cycle();
      }
    }, time * 1000);
  }

  getBackground = (i = 0) => {
    let imgObj = _.get(this.props.module, `contents.images[${i}]`, null);
    if (imgObj) {
      return dp(this.props.screen, imgObj, null);
    }
    return null;
  }

  render() {
    const background = this.getBackground();
    return (
      <div style={{ position: "absolute", width: "100%", height: "100%", backgroundImage: `url(${background})`, backgroundSize: "cover", backgroundRepeat: "none", backgroundPosition: "center" }} />
    );
  }
}

export default AlbuquerqueStoryFullScreen;


// WEBPACK FOOTER //
// ./src/Components/Theme/Albuquerque/AlbuquerqueStoryFullscreen.jsx